import clsx from "clsx";
import { ColorVariant } from "../typography/Typography";
import typo from "../typography/typo.module.scss";
import { IconSize } from "./Icon";
import styles from "./icon.module.scss";

interface Props {
  size?: IconSize;
  color?: ColorVariant;
  className?: string;
}

export default function IconSpinner({ size = "md", color, className }: Props) {
  return (
    <span
      className={clsx(styles.icon, styles[size], styles.spinner, color && typo[color], className)}
      aria-hidden="true"
    />
  );
}
